var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M8.00266 15.9727C7.17696 15.9727 6.47011 15.6789 5.88211 15.0914C5.29411 14.5039 5.00011 13.7977 5.00011 12.9727C5.00011 12.1477 5.29411 11.4414 5.88211 10.8539C6.47011 10.2664 7.17696 9.97266 8.00266 9.97266C8.82836 9.97266 9.53521 10.2664 10.1232 10.8539C10.7112 11.4414 11.0052 12.1477 11.0052 12.9727C11.0052 13.7977 10.7112 14.5039 10.1232 15.0914C9.53521 15.6789 8.82836 15.9727 8.00266 15.9727ZM1.99756 21.9727V19.8727C1.99756 19.4602 2.1039 19.0727 2.31658 18.7102C2.52926 18.3477 2.82326 18.0727 3.19858 17.8852C3.83662 17.5602 4.55598 17.2852 5.35666 17.0602C6.15734 16.8352 7.03934 16.7227 8.00266 16.7227C8.96598 16.7227 9.84798 16.8352 10.6487 17.0602C11.4493 17.2852 12.1687 17.5602 12.8067 17.8852C13.1821 18.0727 13.4761 18.3477 13.6887 18.7102C13.9014 19.0727 14.0078 19.4602 14.0078 19.8727V21.9727H1.99756Z",
          fill: "#5021D1",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9.00269 2.97266C8.4504 2.97266 8.00269 3.42037 8.00269 3.97266V8.97266C8.34995 8.97266 8.68387 9.0131 9.00269 9.0931V8.95508H12.5589V11.4238H11.7012C11.8345 11.7399 11.9245 12.0739 11.9701 12.4238H12.5589V14.9902H11.4639C11.2924 15.2781 11.0808 15.5483 10.83 15.7988C10.7634 15.8654 10.6954 15.9292 10.626 15.9902H12.5589V16.6676C12.7995 16.7697 13.0323 16.8779 13.2574 16.9924C13.362 17.0449 13.4625 17.1022 13.5589 17.1644V15.9902H16.9783V18.9727H14.8824C14.9655 19.2623 15.0078 19.5631 15.0078 19.8727V19.9727H21.0027C21.555 19.9727 22.0027 19.5249 22.0027 18.9727V3.97266C22.0027 3.42037 21.555 2.97266 21.0027 2.97266H9.00269ZM21.0027 3.97266H9.00269V7.95508H21.0027V3.97266ZM17.9783 18.9727V15.9902H21.0027V18.9727H17.9783ZM17.9783 14.9902H21.0027V12.4238H17.9783V14.9902ZM13.5589 14.9902H16.9783V12.4238H13.5589V14.9902ZM13.5589 11.4238V8.95508H16.9783V11.4238H13.5589ZM17.9783 11.4238V8.95508H21.0027V11.4238H17.9783Z",
          fill: "#5021D1",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }